import {processApiRequest} from './../../Common/saga';
import * as ACTION from './constants';
import apiService from './apiService';

export function* cancelDeliveryNote(action) {
    yield processApiRequest(ACTION.CANCEL_DELIVERY_NOTE, () => apiService.cancelDeliveryNote(action.payload.deliveryNoteId), action.payload);
}
